
//import styles from "../style.module.css";
import Accordion from "react-bootstrap/Accordion";
import Top from "../components/Top";
import { useQuery } from "@tanstack/react-query";
import Spinner from 'react-bootstrap/Spinner';
import { API_BASE_URL } from "../api/config";

function Faq() {


  const { data, isLoading, isError } = useQuery({
    queryKey: ['faq'],
    queryFn: async () => {
      const res = await fetch(`${API_BASE_URL}/api/user/pages/faq`);
      return await res.json();
    }
  })



  if (isLoading) {
    return <div className="d-flex flex-column justify-content-center justify-content-center align-items-center" style={{ height: "50vh" }}>
   <Spinner animation="border" role="status" style={{height:"89px", width:"89px"}}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      <p className="mt-3">Kindly be patient while we fetch your data</p>
    </div>
  }
  if (isError) {
    return <p>An error occured!</p>
  }

  return (
    <div className="faq">
      <div className="container faqContent">
        <Accordion defaultActiveKey="0" className="accordion">
          {
            data?.metadata.length > 0 && data?.metadata?.map((f, i) => {
              return <Accordion.Item eventKey={i} className="accItem" key={f.title}>
                <Accordion.Header>
                  {f?.title}
                </Accordion.Header>
                <Accordion.Body>
                  {f?.description}
                </Accordion.Body>
              </Accordion.Item>
            })
          }
        </Accordion>
      </div>
      <Top />
    </div>
  );
}

export default Faq;
